import React, { useMemo } from 'react'
import styles from 'components/Filters/FilterPanel/filter-panel.module.scss'
import PropTypes from 'prop-types'
import SubButtons from 'components/Filters/FilterPanel/subcomponents/SubButtons'
import clsx from 'clsx'
import FilterDropdownButton from 'components/Filters/FilterPanel/subcomponents/FilterDropdownButton'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import 'components/Filters/FilterPanel/filter-panel.scss'
import extractComponents from 'components/Filters/FilterPanel/utils/extractComponents'
import { Grid } from 'gu-ui-kit'

const FilterPanel = ({
  filterManager,
  className,
  ControlWrapper = React.Fragment,
  AdditionalComponents = null,
  Header = null,
}) => {
  const breakpoints = useBreakpoint()
  const { configuration } = filterManager

  if (!configuration) {
    return <></>
  }

  const firstPositionComponents = useMemo(
    () => extractComponents(filterManager, 1, ControlWrapper),
    [configuration, filterManager.filters],
  )

  const secondPositionComponents = useMemo(
    () => extractComponents(filterManager, 2, ControlWrapper),
    [configuration, filterManager.filters],
  )

  return (
    <div className={clsx(styles['filter-panel'], className)}>
      {Header && <Grid>{Header}</Grid>}
      <Grid
        gap={16}
        className={clsx(styles['filter-panel__controls-wrapper'], 'controls-wrapper')}
      >
        {breakpoints.fb && <FilterDropdownButton filterManager={filterManager} />}
        {firstPositionComponents}
        {secondPositionComponents}
        {AdditionalComponents}
      </Grid>
      <SubButtons filterManager={filterManager} />
    </div>
  )
}

FilterPanel.propTypes = {
  filterManager: PropTypes.object,
  className: PropTypes.string,
  ControlWrapper: PropTypes.elementType,
  Header: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.oneOf([null]),
  ]),
  AdditionalComponents: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.oneOf([null]),
  ]),
}

export default FilterPanel
